import BigNumber from 'bignumber.js';

export function getNonNegativeBN(value: BigNumber.Value): BigNumber {
  return BigNumber.max(0, value);
}
